
	import {
		Component,
		Model,
		Prop,
		Vue,
		Watch
	} from "vue-property-decorator";
	
	import Dialog from '@/components/dialog.vue';
	import PickerDate from '@/components/picker-date.vue';
	import PageFooter from '@/components/page-footer.vue';
	
	import {
		profitStatisticserviceFeeList
	} from '@/api/statistic'
	import {
		nextDay
	} from "@/utils"

	@Component({
		name: 'detail-dialog',
		components: {
			'slz-dialog': Dialog,
			PickerDate,
			PageFooter
		}
	})
	export default class DetailDialog extends Vue {
		@Model('change') isShow!: boolean;
		@Prop({}) private id!: any;
		@Prop(String) private filterTime!:string;
		private showDialog = false;
		private loading = false;
		private defaultAvatar = 'https://cdn2024.shiwuzone.com/routuan/image/20230110-0f54988a-9589-45bc-ad27-844c60e80f36.png'
		private list: any = [];
		private pageNo = 1;
		private pageSize = 10;
		private total = 0;
		private keywords = '';
		private type = null;
		private selectList: any = [{
			value: null,
			label: '全部'
		}, {
			value: 1,
			label: '零售利润'
		}, {
			value: 2,
			label: '分销利润'
		}, {
			value: 3,
			label: '服务费'
		}];
		

		@Watch('isShow')
		private onChangeShow(val: boolean) {
			this.showDialog = val;
			if (val) {
				this.getList();
			}
		}

		private handleClose() {
			this.clearSearch(false)
			this.$emit('change', false);
		}
		
		private changePage(e) {
			this.pageNo = +e;
			this.getList();
		}
		
		private doSearch() {
			this.pageNo = 1;
			this.getList();
		}
		
		private clearSearch(needget?:boolean) {
			this.pageNo = 1;
			this.keywords = '';
			this.type = null;
			if(!needget) return
			this.getList();
		}
		
		private async getList() {
			let params: any = {
				Skip: (this.pageNo - 1) * this.pageSize,
				Take: this.pageSize,
				MemberId: this.id.MemberId,
				RoleGrade:this.id.RoleGrade,
				SuperId:this.id.SuperId,
				Keywords: this.keywords,
				StartTime:'',
				EndTime:'',
			}
			if (this.filterTime) {
				var dt = this.filterTime.split('/');
				params.StartTime = dt[0];
				params.EndTime = nextDay(dt[1],1)
			}
			this.loading = true;
			try {
				const res: any = await profitStatisticserviceFeeList(params);
				this.list = res.Result.Results
				this.total = res.Result.Total;
			} catch (e) {
				console.log(e)
			} finally{
				this.loading = false;
			}
		}
		
		/**
		 * 导出
		 */
		private exportExcel(){
			var url = location.origin + '/pc/profitStatistic/serviceFeeExport?';
			url += 'Keywords=' + this.keywords;
			url += '&MemberId=' + this.id.MemberId;
			url += '&RoleGrade=' + this.id.RoleGrade;
			url += '&SuperId=' + this.id.SuperId;

			if (this.filterTime) {
				var dt = this.filterTime.split('/');
				url += '&StartTime=' + dt[0];
				url += '&EndTime=' + nextDay(dt[1],1);
			}
			
			// console.log(url)
			window.open(url)
			
		}
		
	}
